// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import VueCookies from 'vue-cookies'
import plugins from './libraries/plugins'
import common from "./common/index.js"
import moment from 'moment';
import {
	tableSticky
} from 'lp-vue'

import VueQuillEditor from 'vue-quill-editor'
import { initPddOpenAndReport } from './libraries/utils/pddPati'

Vue.config.productionTip = false;

// 尽早启动 pagecode/pati，业务请求经 axios 拦截器等待就绪后再发出
initPddOpenAndReport()

Vue.use(ElementUI);
Vue.use(VueCookies);
Vue.use(plugins);
Vue.use(common);
Vue.use(VueQuillEditor);
Vue.directive('tableSticky', tableSticky);
Vue.prototype.$moment = moment;

router.beforeEach((to, from, next) => {
	next();
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js